import { ClientDestinationDetails } from 'models/ClientDestinationDetails';
import { httpService } from 'services/httpService';

class ClientDestinationService {
  clientDestinationDetails(notificationId: string) {
    return httpService.get<ClientDestinationDetails>(`/ClientDestinationVersion/Detail/${notificationId}`);
  }

  approveClientDestination(notificationId: string, blockchain: string) {
    return httpService.post<{notificationId: string, success: boolean}>(`/ClientDestinationVersion/Vote/${notificationId}?vote=true&blockchain=${blockchain}`);
  }

  rejectClientDestination(notificationId: string, blockchain: string) {
    return httpService.post<{notificationId: string, success: boolean}>(`/ClientDestinationVersion/Vote/${notificationId}?vote=false&blockchain=${blockchain}`);
  }
}

export const clientDestinationService = new ClientDestinationService();
